<template>
  <div>
    <el-form ref="form" label-position="top" class="background-form">
      <el-form-item :label="$t('text.logo')">
        <el-upload
          drag
          action="#"
          :http-request="customUpload"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :show-file-list="false"
        >
          <div class="image-operate-btn" v-if="logo">
            <el-tooltip :content="$t('text.crop_image')" placement="top">
              <i
                class="el-icon-edit btn-item"
                @click.stop="openCropImageDialog"
              ></i>
            </el-tooltip>
            <el-tooltip :content="$t('text.remove_image')" placement="top">
              <i class="el-icon-close btn-item" @click.stop="handleRemove"></i>
            </el-tooltip>
          </div>
          <img v-if="logo" :src="logo" class="max-wp-100 max-hp-100" />
          <div v-else v-loading="loading">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              {{ $t('text.drag_the_logo_here') }}, {{ $t('text.or')
              }}<em> {{ $t('text.click_upload') }}</em>
            </div>
          </div>
          <div class="el-upload__tip" slot="tip">
            <div>1. {{ $t('text.only_image_files_can_be_uploaded') }}</div>
            <div>
              2. {{ $t('text.the_size_of_the_uploaded_image_cannot_exceed') }}
            </div>
          </div>
        </el-upload>
      </el-form-item>
      <el-divider />
      <el-form-item :label="$t('text.logo_shape')">
        <span class="mr-10">{{ $t('text.show_as_circle') }}</span>
        <el-switch v-model="isCircleLogo" @change="applyChange()"> </el-switch>
        <span
          class="ml-10"
          :class="isCircleLogo ? 'primary-font' : 'secondary-font'"
          >({{ isCircleLogo ? $t('text.on') : $t('text.off') }})</span
        >
      </el-form-item>
    </el-form>
    <CropImage ref="cropImage" :image="logo" @completeCrop="completeCrop" />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import CropImage from '@/components/manage/admin/customization/CropImage'
export default {
  data() {
    return {
      logo: '',
      loading: false,
      isCircleLogo: false
    }
  },
  components: {
    CropImage
  },
  mounted() {
    if (this.$store.state.customization.logo) {
      this.logo = this.$store.state.customization.logo
    }
    if (this.$store.state.customization.isCircleLogo) {
      this.isCircleLogo = this.$store.state.customization.isCircleLogo
    }
  },
  methods: {
    applyChange() {
      this.$store.commit('customization/SET_LOGO', this.logo)
      this.$store.commit('customization/SET_IS_CIRCLE_LOGO', this.isCircleLogo)
    },
    customUpload(params) {
      const file = params.file
      this.loading = true
      let obj = new FormData()
      obj.append('file', file)
      ApiService.UploadIMGFile('logo', obj)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.logo = response.data.data
            this.applyChange()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    beforeUpload(file) {
      const allowType = ['image/jpeg', 'image/png']
      const isImg = allowType.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error(this.$t('text.only_image_files_can_be_uploaded'))
      }
      if (!isLt2M) {
        this.$message.error(
          this.$t('text.the_size_of_the_uploaded_image_cannot_exceed')
        )
      }

      return isImg && isLt2M
    },
    handleRemove() {
      this.logo = ''
    },
    openCropImageDialog() {
      this.$refs.cropImage.openDialog()
    },
    completeCrop(image) {
      this.logo = ''
      this.customUpload({
        file: image
      })
    }
  }
}
</script>
